import gql from 'graphql-tag';

import type { ProjectSectionSummary } from 'src/data/project';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationRenameProjectSectionArgs } from 'src/types/backend';

import { FRAGMENT_PROJECT_SECTION } from './schema';

const MUTATION = gql`
  mutation RenameProjectSection($id: ID!, $name: String!) {
    renameProjectSection(id: $id, name: $name) {
      ...ProjectSectionFields
    }
  }
  ${FRAGMENT_PROJECT_SECTION}
`;

export const renameProjectSection = async (
  variables: BackendMutationRenameProjectSectionArgs
): Promise<ProjectSectionSummary | undefined> => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<ProjectSectionSummary>(response.data);
};
